import { render, staticRenderFns } from "./SiteMenuIcon.vue?vue&type=template&id=2d89e9e6&"
import script from "./SiteMenuIcon.vue?vue&type=script&lang=js&"
export * from "./SiteMenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./SiteMenuIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports